import React from 'react';
import queryString from 'query-string'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import BarcodeReader from 'react-barcode-reader'

import CssBaseline from "@material-ui/core/CssBaseline";
import MiniDrawer from "../navigation/DrawerMenu";
import Grid from "@material-ui/core/Grid";
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import MuiAlert from '@material-ui/lab/Alert';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import Paper from '@material-ui/core/Paper'
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigatePrevIcon from '@material-ui/icons/NavigateBefore';
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'
import { ProductService} from '../../_services/product.service'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import { Switch as ConditionalSwitch, Case, Default } from 'react-if'
import { Warehouse } from "../../_helpers/auth-header";
import ImageWithStatus from "../../components/ImageWithStatus";

const styles = theme => ({
    root: {
        minWidth: 275,
    },

    mainGrid: {
        width: '100vw',
        height: '100vh',
        spacing: 0,
        justify: 'space-around'
    },

    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },

});

function setTabSelectedId(delta) {
    console.log(delta);
    return (previousState, currentProps) => {
        return { ...previousState, selectedId: delta };
    };
}

class SalesScanDetail extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            checked: true,
            barcode: '1234',
            value: '',
            alertmessage: '',
            open: false,
            severity: "success",
            ProductName:'',
            divStyle: { height: '60vh', marginTop: '40px', marginLeft: 'auto', marginRight: 'auto', width: '80vw', padding: '20px' },
            divStyleSales: { marginTop: '40px', marginLeft: 'auto', marginRight: 'auto', width: '80vw', padding: '20px' }
        };
             
        this.checkCode = this.checkCode.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handleScan = this.handleScan.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount()
    {      
    }
    handleClose = (event, reason) => {
        if (this.state.severity === "error") {
            this.setState({ open: false });
        }
    };
    fetchData(id) {
        ProductService.fetchData(id)
            .then(response => response.json())
            .then(({ productName, productNumber,color }) => {
                if (productName) {
                    this.setState({
                      
                        alertmessage: "",
                        ProductName: productName + '(' + productNumber + ')',
                        divStyleSales: { marginTop: '40px', marginLeft: 'auto', marginRight: 'auto', width: '80%', padding: '20px', backgroundColor: color }
                    });
                }
                else {
                    this.setState({
                        alertmessage: "Geen product gevonden of ongeldige barcode",
                        severity: "error",
                        open: true
                    });
                }
            });
    }
   
    getDetails(id)
    {
        this.setState({checked:false});
        this.fetchData(id, this.state.itemStatus);
    }

    handleScan(data) {
        this.setState({
            barcode: data.toUpperCase(),
            value: data.toUpperCase()
        })
        if (this.state.value.length > 12) {
            var productNumber = this.state.value.substring(3, 7);
            this.fetchData(productNumber);
            this.setState({ value: "" });
        }
    }

    checkCode() {
       
        if (this.state.value.length === 4) {
            this.getDetails(this.state.value);
        }
        else {
            if (this.state.value.length > 12) {
                var productNumber = this.state.value.substring(3, 7);
                this.fetchData(productNumber);
                this.setState({ value: "" });
            }
        }
    }
    handleError(err) {
        console.error(err);
    }
    handleChange = (e) => {
        this.setState({ value: e.target.value });
    };
    render(){
        const result = this.state.result;
        const { classes } = this.props;
        return (
            <React.Fragment>
                <CssBaseline />
               
                    <Grid className={classes.root.mainGrid}>
                     
                    <BarcodeReader minLength="13" timeBeforeScanTest="200" avgTimeByChar="80"
                                onError={this.handleError}
                                onScan={this.handleScan}
                    />
        
                            <Snackbar
                                open={this.state.open}
                                onClose={()=>{this.handleClose()}}
                                autoHideDuration={3000}
                            >
                                <Alert onClose={()=>{this.handleClose()}} severity={this.state.severity}>
                                    {this.state.alertmessage}
                                </Alert>
                            </Snackbar>
                    <Grid container spacing={2}>
                        <Paper style={this.state.divStyle}>
                        Scan een artikel, of vul de barcode of Brooklyn-ID (4 cijfers) in het tekst veld in.<br/>
                            <input type="text" value={this.state.value} onChange={this.handleChange} />
                            <button onClick={() => { this.checkCode(); }}>Controleer</button>
                            <Paper style={this.state.divStyleSales}>
                                <h2>{this.state.ProductName}</h2>
                            </Paper>
    (Gescande barcode : {this.state.barcode})
                        </Paper>
                    </Grid>           



                    </Grid>
             
            </React.Fragment>
        );
    }
}

SalesScanDetail.propTypes = {
    classes: PropTypes.object.isRequired,
};
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default withStyles(styles)(SalesScanDetail);
